import Brand from "../pages/single_brand/Brand";
import Brands from "../pages/brands/Brands";
import ChangePassword from "../pages/change_password/ChangePassword";
import DiscountCoupon from "../pages/discount_coupon/DiscountCoupon";
import ForgotPassword from "../pages/forgot_password/ForgotPassword";
import HelpCenterForm from "../pages/help_center/HelpCenter";
import OrderStatus from "../pages/order_status/OrderStatus";
import OrderSuccess from "../pages/order_success/OrderSucess";
import OTPPage from "../pages/otp/Otp";
import Payment from "../pages/payment/Payment";
import PentagonPoints from "../pages/points/Points";
import Portal from "../pages/settings/Portals";
import Profile from "../pages/profile/Profile";
import SellersPage from "../pages/sellers/Seller";
import YourOrder from "../pages/your_order/YourOrder";
import { PrivacyPolicy } from "../pages/privacy/privacy";
import { Terms } from "../pages/terms/terms";
import AllProducts from "../pages/all_products/AllProducts";
import EnterOtpPage from "../pages/otp/RecentOtp";
import AddressForm from "../pages/address/Address";
import WalletUI from "../pages/wallet/Wallet";
import B2BCredit from "../pages/b2b/B2Bcredit";
import Wishlist from "../pages/wishlist/Wishlist";
import ProductDetails from "../pages/product_details/ProductsDetails";
import Page404 from "../components/Page404";
import Shopcart from "../pages/shop_cart/Shopcart";
import AfterRegistration from "../pages/email_verification/email_verification";
import Review from "../pages/order_status/Review";
import DeleteMyAccount from "../pages/delete_my_account/delete_my_account";
import Clothing from "../pages/main/Clothing";
import SellersProflie from "../pages/SellersProflie/SellersProflie";
import Shiping from "../pages/Shipping address/Shippingaddress";
import AddressEdit from "../pages/address/AddressEdit";
import BuyNow from "../pages/shop_cart/BuyNow";
import GlobalStore from "../pages/GlobalStore/GlobalStore";
import CreditDetails from "../pages/b2b/CreditDetails";
import TopBrand from "../pages/single_brand/TopBrand";
import NewBrand from "../pages/single_brand/NewBrand";
import TrackPage from "../pages/order_status/TrackPage";
import DedicatedReview from "../pages/product_details/DedicatedReview";
import PlsPrivacyPolicy from "../pages/pls_deliveryboy/PlsPrivacyPolicy";
import PlsTerms from "../pages/pls_deliveryboy/PlsTerms";
import PlsDeleteMyAccount from "../pages/pls_deliveryboy/PlsDeleteMyAccount";
export const openRoutes = [
  {
    path: "/",
    element: <Clothing />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/brands",
    element: <Brands />,
  },
  {
    path: "/shipping_address",
    element: <Shiping />,
  },
  {
    path: "/billing_address",
    element: <Shiping />,
  },
  {
    path: "/brand",
    element: <Brand />,
  },

  {
    path: "/top_brand",
    element: <TopBrand />,
  },
  {
    path: "/new_brand",
    element: <NewBrand />,
  },
  {
    path: "/points",
    element: <PentagonPoints />,
  },
  {
    path: "/creditDetails",
    element: <CreditDetails />,
  },
  {
    path: "/order_status",
    element: <OrderStatus />,
  },
  {
    path: "/review",
    element: <Review />,
  },
  { path: "/track/:id", element: <TrackPage /> },
  {
    path: "/seller",
    element: <SellersPage />,
  },

  {
    path: "/sellerProFile/:id",
    element: <SellersProflie />,
  },
  {
    path: "/order_success",
    element: <OrderSuccess />,
  },
  {
    path: "/otp",
    element: <OTPPage />,
  },
  {
    path: "/discount_coupon",
    element: <DiscountCoupon />,
  },
  {
    path: "/forgot_password",
    element: <ForgotPassword />,
  },
  {
    path: "/change_password",
    element: <ChangePassword />,
  },
  {
    path: "/global_store2",
    element: <GlobalStore />,
  },
  { path: "/DedicatedReview/:productId", element: <DedicatedReview /> },
  {
    path: "/global_store",
    element: <AllProducts />,
  },

  {
    path: "/products",
    element: <AllProducts />,
  },
  {
    path: "/recent_otp",
    element: <EnterOtpPage />,
  },
  {
    path: "/address",
    element: <AddressForm />,
  },
  {
    path: "/addressedit",
    element: <AddressEdit />,
  },
  {
    path: "/wallet",
    element: <WalletUI />,
  },
  {
    path: "/b2b_store",
    element: <AllProducts />,
  },
  {
    path: "/b2b_credit",
    element: <B2BCredit />,
  },
  {
    path: "/email_verification",
    element: <AfterRegistration />,
  },
  {
    path: "/products/:id",
    element: <ProductDetails />,
  },
  {
    path: "/review/:id",
    element: <Review />,
  },
  {
    path: "*",
    element: <Page404 />,
  },

  {
    path: "/SellersProflie",
    element: <SellersProflie />,
  },
];

export const protectedRoutes = [
  {
    path: "/wishlist",
    element: <Wishlist />,
  },
  {
    path: "/shop_cart",
    element: <Shopcart />,
  },
  {
    path: "/buy_now",
    element: <BuyNow />,
  },
  {
    path: "/setting",
    element: <Portal />,
  },
  {
    path: "/my_address",
    element: <Shiping />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/your_order",
    element: <YourOrder />,
  },
  {
    path: "/help_center",
    element: <HelpCenterForm />,
  },
];

export const routeSharedWithApp = [
  {
    path: "/delete-my-account",
    element: <DeleteMyAccount />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/delete_my_account",
    element: <DeleteMyAccount />,
  },
  {
    path: "/privacy_policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/pls/privacy_policy",
    element: <PlsPrivacyPolicy />,
  },
  {
    path: "/pls/terms",
    element: <PlsTerms />,
  },
  {
    path: "/pls/delete_my_account",
    element: <PlsDeleteMyAccount />,
  },
  {
    path: "/terms_and_condition",
    element: <Terms />,
  },
];
